import * as angular from "angular";

angular
  .module('bringoz.admin.recommendation')
  .service('recommendationService', RecommendationService);

/* @ngInject */
function RecommendationService() {

  return {
    // Service methods will be added here
  };
}

